<template>
  <div class="cw-lobby">
    <template v-if="this.hasLobbyData">
      <div class="cw-lobby-title">{{ this.title }}</div>
      <div class="cw-lobby-description" v-html="this.messageAsHtml"></div>

      <slot />

      <div class="cw-actions-holder">
        <div class="cw-action" v-for="action in this.actions" :key="action.id">
          <button @click="this.actionClick(action)" :class="{ 'use-custom-padding': this.useCustomPadding }">
            {{ this.actionText(action) }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import useAppStore from "@/store/app";
import { ChatWidgetActionItemData, ChatWidgetPublicSettingsData } from "@/TickApi";
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import { debug, error } from "@/log";

@Component({
  emits: ["onAction"],
  components: {},
})
export default class Lobby extends Vue {
  @Prop({ default: null }) private settings?: ChatWidgetPublicSettingsData;

  private actionClick(action: ChatWidgetActionItemData) {
    debug(`option "${action.text} chosen"`);
    this.$emit("onAction", action.id)
  }

  private get hasLobbyData(): boolean {
    return this.title?.length > 0
      || this.messageAsHtml?.length > 0
      || (this.actions && this.actions.length > 0);
  }

  private get lobbySettings() {
    return this.settings
      ? this.settings.lobby
      : useAppStore().cwSettings.lobby;
  }

  private get title() {
    return this?.lobbySettings?.title || "";
  }

  private get messageAsHtml() {
    return this?.lobbySettings?.messageHtml || this?.lobbySettings?.message || "";
  }

  private get actions() {
    return this?.lobbySettings?.actions || [];
  }

  private get useCustomPadding() {
    return this?.lobbySettings?.actionsStyling?.useCustomPadding;
  }

  private actionText(action: ChatWidgetActionItemData) {
    const str = action.text;
    const isEmpty = (str === null || str.match(/^ *$/) !== null);

    return isEmpty ? "-" : action.text;
  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-lobby {
  color: var(--cw-fg-color);
  display: grid;
  gap: 20px;
  grid-template-rows: auto auto 1fr;
  grid-template-columns: 100%;
  padding: 0px 20px;


  .cw-lobby-title {
    margin-top: 10px;

    font-size: clamp(18px, 2em, 150px);
    font-weight: 600;
  }

  .cw-lobby-description {
    font-family: var(--cw-font-family);
    font-size: clamp(15px, 1.5em, 100px);
    font-weight: 100;
  }

  .cw-actions-holder {
    //padding: 0 20%;
    margin-top: 10px;
    display: flex;
    gap: 15px;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 1;
    margin-bottom: 20px;

    .cw-action {
      width: 100%;

      button {
        cursor: pointer;
        line-height: 24px;
        padding: 4px 16px;

        &.use-custom-padding {
          padding: var(--cw-lobby-actions-padding);
        }

        background: var(--cw-lobby-actions-bg-color);
        color: var(--cw-lobby-actions-fg-color);
        border: solid var(--cw-lobby-actions-border-width) var(--cw-lobby-actions-border-color);
        border-radius: var(--cw-lobby-actions-border-radius);
        font-family: var(--cw-lobby-actions-font-family);
        font-size: var(--cw-lobby-actions-font-size);
        box-shadow: var(--cw-lobby-actions-drop-shadow);

        &:hover {
          filter: contrast(120%);
        }
      }
    }
  }
}

/* For Mobile */
@media screen and (hover: none) and (orientation:portrait),
screen and (max-width: 800px) {

  .cw-lobby {
    gap: 4vw !important;

    .cw-lobby-title {
      margin-top: 4vw !important;
      font-size: 3em;
    }

    // .cw-lobby-description {
    //   font-size: 2em;
    // }

    .cw-actions-holder {
      justify-content: end !important; // push buttons to text area

      .cw-action {
        display: grid !important;


        button {
          line-height: 24px !important;
          padding: 20px 16px !important;

        }
      }
    }
  }
}
</style>